<p-toast position="bottom-left">
</p-toast>

<div class="login">
  @if(imagePath){
  <div class="col-left" [ngStyle]="{ 'background-image': 'url(' + imagePath + ')' }">
  </div>
  }
  @if(imagePath == undefined){
  <div class="col-left">
    <div class="swiper mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="assets/images/slide-1.jpg" />
          <div class="slider-caption">
            <p>Pursue the perfect<br />customer experience.</p>
          </div>
        </div>
        <div class="swiper-slide">
          <img src="assets/images/slide-2.jpg" />
          <div class="slider-caption">
            <p>Listen, aggregate and<br />act across every channel.</p>
          </div>
        </div>
        <div class="swiper-slide">
          <img src="assets/images/slide-3.jpg" />
          <div class="slider-caption">
            <p>Say hello to RefleCX. Everything<br />you need for proactive CX.</p>
          </div>
        </div>
      </div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
  }
  <div class="col-right">
    <form [formGroup]="setPassForm" style="height: 100%">
      <div class="login-form">
        <div class="form">
          <div class="form__inner">
            <div class="form__header">
              <div class="login-logo">
                <img src="assets/images/logo.svg">
              </div>

              <h4>Thank you for confirming code</h4>
              <p class="small-text">Please set password for your account</p>
            </div>

            <fieldset class="form__group" [ngClass]="{
                'error--field':
                  isPasswordPolicyError || (submitted && f['newPassword'].errors && f['newPassword'].errors['required'])
              }">
              <label class="form__label">ENTER PASSWORD</label>
              <div class="form__field">
                <div class="password-strength">
                  <input type="Password" formControlName="newPassword" (keyup)="onPaswordChange($event)"
                    class="form__input" autocomplete="new-form" />
                  <!-- <div class="password-strength-bar">
                    @if(strengthColor){
                    <div class="password-strength-block weak"></div>
                    }
                    @if(strengthColor == 'orange'){
                    <div class="password-strength-block moderate"></div>
                    }
                    @if(strengthColor == 'orange'){
                    <div class="password-strength-block moderate"></div>
                    }
                    @if(strengthColor == 'green'){
                    <div class="password-strength-block strong"></div>
                    }
                    @if(strengthColor == 'green'){
                    <div class="password-strength-block strong"></div>
                    }
                    @if(strengthColor == 'green'){
                    <div class="password-strength-block strong"></div>
                    }
                  </div> -->
                </div>
              </div>
                <password-strength-meter class="psm-wrapper" (strengthChange)="onPasswordStrengthChanged($event)"
                                         [password]="f['newPassword'].value!" [enableFeedback]="true" [minPasswordLength] = "minPasswordLength" [passwordPolicy]="passwordPolicy" [numberOfProgressBarItems]="policiesCount">
                </password-strength-meter>
              @if(submitted){
              <div class="field__error">
                @if(f['newPassword'].errors && f['newPassword'].errors['required']){
                <p>
                  {{ 'New password is required.' }}
                </p>
                }
                @if(!f['newPassword'].errors == null && passwordPolicy != null && isPasswordPolicyError){
                <p>
                  {{ passwordPolicyError }}
                </p>
                }
              </div>
              }
            </fieldset>

            <fieldset class="form__group" [ngClass]="{
                'error--field':
                  submitted &&
                  ((f['confirmPassword'].errors && f['confirmPassword'].errors['required']) ||
                    (f['confirmPassword'].errors && f['confirmPassword'].errors['mustMatch']))
              }">
              <label class="form__label">RE-TYPE PASSWORD</label>
              <div class="form__field">
                <input type="Password" formControlName="confirmPassword" class="form__input" autocomplete="new-form" />
              </div>
                              @if(submitted){
                <div class="field__error">
                  @if(f['confirmPassword'].errors && f['confirmPassword'].errors['required']){
                  <p>
                    {{ 'Confirm password is required.' }}
                  </p>
                  }
                  @if(f['confirmPassword'].errors && f['confirmPassword'].errors['mustMatch']){
                  <p>
                    {{ 'Password must Match.' }}
                  </p>
                  }
                </div>
                }
            </fieldset>

            <fieldset class="form__group">
              @if(passwordPolicy != null){
              <div>
                <p class="password-hints-title">PASSWORD HINT</p>
                <div class="password-hints">
                  <ul class="">
                    @if(passwordPolicy.IsUpperCase){
                    <li>New Password must have at least one upper case character
                    </li>
                    }
                    @if(passwordPolicy.IsLowerCase){
                    <li>
                      Must have at least one lower case character
                    </li>}
                    @if(passwordPolicy.IsSpecialCharacter){
                    <li>Must have at least one symbol
                    </li>
                    }
                    @if(passwordPolicy.IsDigit){
                    <li>Must have at least one digit
                    </li>
                    }
                    @if(passwordPolicy.Length > 0){
                    <li>
                      Password must be minimum {{ passwordPolicy.Length }} characters long
                    </li>
                    }
                  </ul>
                </div>
              </div>
              }
            </fieldset>

            <fieldset class="form__group login--actions">
              <div class="auth-button">
                <button class="login-btn" type="button" (click)="setPassword()">CHANGE</button>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>